<template>
  <el-form-item
    :label="label"
    class="customer-code"
    :prop="prop"
    :rules="rules"
  >
    <el-autocomplete
      v-model="customerCode"
      :clearable="true"
      :maxlength="5"
      :placeholder="placeholder"
      :disabled="disabled"
      :fetch-suggestions="querySearch"
      :trigger-on-focus="false"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import AutocompleteFilter from '@/mixins/AutocompleteFilter.vue'
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    AutocompleteFilter,
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '顧客コード'
    },
    prop: {
      type: String,
      default: 'customer_code'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: this.searchCond ? '前方一致' : '半角英数（最大5文字）'
    }
  },
  computed: {
    customerCode: {
      get () {
        return this.value
      },
      set (customerCode) {
        this.$emit('input', customerCode.toUpperCase())
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
          rules.push(this.validatorHalfUCaseAlphabetNumber(this.label, 'blur'))
        }
        return rules
      }
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.customer-code {
  ::v-deep .el-form-item__content {
    width: 8.5em;
  }
}
</style>
